// @flow

import Immutable, {fromJS, type Map} from 'immutable';

import {
  REQUEST_PROCESS_LIST,
  RECEIVE_PROCESS_LIST,
  RECEIVE_PROCESS_DETAIL,
  INVALIDATE_PROCESS_LIST,
  REQUEST_PROCESS_DASHBOARD_LIST,
  RECEIVE_PROCESS_DASHBOARD_LIST,
  TOGGLE_PROCESS_DASHBOARD_RELATION,
  RECEIVE_PROCESS_VERSION_DETAIL,
  RECEIVE_PROCESS_VERSIONS_LIST,
  SET_PROCESS_SIDE_DIAGRAM_STATE,
} from './actions';
import {
  mergeNormalizedFetchData,
  defaultFetchDataFormat,
} from 'app/utils/redux';
import {setNormalizedList} from 'app/utils/redux_v2';
import type {ProcessVersionType} from 'app/process/types';

const buildSingleItemEndpointResponse = (item: any) => ({
  results: [item],
  previous: null,
  next: null,
  num_pages: 1,
  count: 1,
});

const updateVersion = (state, version: ProcessVersionType) => {
  const path = ['versions', version.version_object_id.toString()];

  return state.setIn(
    path,
    mergeNormalizedFetchData(
      buildSingleItemEndpointResponse(version),
      state.getIn(path)
    )
  );
};

const processArea = (
  state: Map<string, any> = (fromJS({
    isFetching: false,
    isInvalid: false,
    processes: defaultFetchDataFormat(),
    versions: defaultFetchDataFormat(),
    closedSideDiagrams: {},

    // v2 reducers
    byId: {},
    queries: {},
    dashboard: {
      currentFilters: {},
      activeRelations: {},
    },
  }): any),
  action: any
): Map<string, any> => {
  switch (action.type) {
    case INVALIDATE_PROCESS_LIST:
      return state.set('isInvalid', true);
    case REQUEST_PROCESS_LIST:
      return state.set('isFetching', true);

    case RECEIVE_PROCESS_LIST:
      return state
        .set(
          'processes',
          mergeNormalizedFetchData(action.items, state.get('processes'))
        )
        .set('isInvalid', false)
        .set('isFetching', false);

    case RECEIVE_PROCESS_DETAIL: {
      const process = (Immutable.fromJS(action.item): any);
      return state.setIn(
        ['processes', 'byId', process.get('id').toString()],
        process
      );
    }

    case RECEIVE_PROCESS_VERSION_DETAIL:
      return updateVersion(state, action.version);

    case RECEIVE_PROCESS_VERSIONS_LIST: {
      const path = ['versions', action.processId.toString()];

      // $FlowFixMe chained sets seems to be bogus in immutalbe
      return state.set('isFetching', false).setIn(
        path,
        mergeNormalizedFetchData(
          action.data,
          state.getIn(path),
          // reset allIds if we are fetching the first page
          !!action.data.previous
        )
      );
    }

    case REQUEST_PROCESS_DASHBOARD_LIST:
      return state
        .setIn(['dashboard', 'currentFilters'], fromJS(action.currentFilters))
        .set('isInvalid', false)
        .set('isFetching', true);

    case RECEIVE_PROCESS_DASHBOARD_LIST:
      return setNormalizedList(action.query, action.response, state).set(
        'isFetching',
        false
      );

    case TOGGLE_PROCESS_DASHBOARD_RELATION: {
      const path = ['dashboard', 'activeRelations', action.relation];
      return state.setIn(path, !state.getIn(path));
    }

    case SET_PROCESS_SIDE_DIAGRAM_STATE: {
      return state.setIn(
        ['closedSideDiagrams', action.processId.toString()],
        action.closed
      );
    }

    default:
      return state;
  }
};

export default processArea;
